import { inmersysVrApi, isConnected } from "./api";
import { Endpoints } from "./enpoints";

const responseAxios = (status = 0, msg = "", payload = null) => {
	return {
		status,
		msg,
		payload,
	};
};

// auth
export const loginAdmin = async (emailUser, password) => {
	try {
		if (isConnected) {
			const response = await inmersysVrApi.post(Endpoints.auth.login, { email: emailUser, password });
			return responseAxios(response.data.status, response.data.message, { token: response.data.token, email: response.data.email });
		} else {
			return responseAxios(0, "ok not internet", { token: "000-00-00-00", email: "admin@admin.com" });
		}
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};

export const getDataAdmin = async () => {
	try {
		if (isConnected) {
			const { data } = await inmersysVrApi.get(Endpoints.admin.getInfo);
			return responseAxios(data.status, data.message, { ...data });
		} else {
			return responseAxios(0, "ok not internet", {
				name: "not-int-vrt",
				email: "admin@admin.com",
				typeUser: "VRT",
				enterprise: {
					_id: "000-000-000",
					name: "empresnointernet",
					imgUrl: "none",
				},
			});
		}
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};

export const requestNewPassword = async (email) => {
	try {
		const { data } = await inmersysVrApi.post(Endpoints.auth.requestNewPassword, { email });
		return responseAxios(data.status, data.message, { ...data });
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};

export const changePassword = async (newPassword, token) => {
	try {
		const { data } = await inmersysVrApi.post(`${Endpoints.auth.changePassword}${token}`, { newPassword });
		return responseAxios(data.status, data.message, { ...data });
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};
// end auth

// Admin
export const createNewAdmin = async (payload) => {
	try {
		const { data } = await inmersysVrApi.post(Endpoints.admin.createAdmin, {
			name: payload.userName,
			email: payload.email,
			password: payload.password,
			enterpriseId: payload.enterpriseId,
			typeUser: payload.typeUser,
		});
		return responseAxios(data.status, data.message, { ...data });
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};
export const onGetAllProyectsByEnterpiseID = async (enterpiseId = "") => {
	try {
		const { data } = await inmersysVrApi.get(Endpoints.admin.getProyectsById + enterpiseId);
		return responseAxios(data.status, data.message, { ...data });
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};
//

// enterpise
export const onNewEnterpise = async (imgUrl, name) => {
	try {
		const { data } = await inmersysVrApi.post(Endpoints.enterprise.create, {
			imgUrl,
			name,
		});
		return responseAxios(data.status, data.message, { ...data });
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};

export const onGetAllEnterpriseds = async () => {
	try {
		const { data } = await inmersysVrApi.get(Endpoints.enterprise.getAll);
		return responseAxios(data.status, data.message, { ...data });
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};

export const onChangeStatusEnterpise = async (id) => {
	try {
		const { data } = await inmersysVrApi.delete(Endpoints.enterprise.disabed + id);
		return responseAxios(data.status, data.message, { ...data });
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};

// projects
export const onGetAllProyectsByenterpiseIdToken = async () => {
	try {
		const { data } = await inmersysVrApi.get(Endpoints.project.allProjectsForId);
		return responseAxios(data.status, data.message, { ...data });
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};

export const onGetAllResponsesByProjectId = async (proyectId) => {
	try {
		const data = await inmersysVrApi.get(Endpoints.project.allresponsesbyproyectid + "?projectId=" + proyectId);
		return responseAxios(data.data.status, data.data.message, { ...data.data });
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};

export const onCreateProject = async (name, enterpriseId) => {
	try {
		const { data } = await inmersysVrApi.post(Endpoints.project.createProyect, {
			name,
			enterpriseId,
		});
		return responseAxios(data.status, data.message, { ...data });
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};
export const onGetDetailProyectsByEnterpiseId = async (id) => {
	try {
		const { data } = await inmersysVrApi.post(Endpoints.project.detailsProyecstbyEnterpiseId + id, {});
		return responseAxios(data.status, data.message, { ...data });
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};
//
// groups
export const onCreateGroup = async (name, projectId) => {
	try {
		const { data } = await inmersysVrApi.post(Endpoints.gruop.create, {
			name,
			projectId,
		});
		return responseAxios(data.status, data.message, { ...data });
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};

export const onEditGroup = async ({ name, groupId }) => {
    try {
        const { data } = await inmersysVrApi.put(Endpoints.gruop.create, {
            name,
            groupId,
        });
        return responseAxios(data.status, data.message, { ...data });
    } catch (error) {
        console.log("error", error.response.data.errors);
        return responseAxios(1, "error", error.response.data.errors);
    }
};
export const onGetAlLGroupsByProjectId = async (proyectId) => {
    try {
        const { data } = await inmersysVrApi.get(Endpoints.gruop.getAllByProyectId + proyectId);
        console.log(data)
        const sortedGrups = [...data.groups].sort((a, b) =>
            a.name.localeCompare(b.name) // Ordena por el campo 'name'
        );
        return responseAxios(data.status, data.message, { ...data, groups: sortedGrups });
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};

export const onGetAllAlumsByGroups = async (groups) => {
	try {
        const grupoNew = groups.map(async (grup) => {
            const { data: students } = await inmersysVrApi.get("/student/byGroup/" + grup._id);
            return {
                data: {
                    group_id: grup._id,
                    ...students,
                }
            }
        })
        const usersbygrup = await Promise.all(grupoNew);
		return usersbygrup.map((gr) => gr.data);
	} catch (error) {
		console.log("error", error);
		return responseAxios(1, "error", error);
	}
};
//
// student

export const onCreateStudent = async (name, userId, groupId) => {
	try {
		const { data } = await inmersysVrApi.post(Endpoints.student.createone, {
			name,
			userId: userId,
			groupId,
		});
		return responseAxios(data.status, data.message, { ...data });
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};
export const onCreateManyStudent = async (students, learningGroupId) => {
	try {
		const { data } = await inmersysVrApi.post(Endpoints.student.createMany, {
			students,
			learningGroupId,
		});
		return responseAxios(data.status, data.message, { ...data });
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};

export const onEditStudenApi = async (student) => {
	try {
		const { data } = await inmersysVrApi.put(Endpoints.student.editStudent, {
			studentId: student._id,
			name: student.name,
			userId: student.userId,
            groupId: student.groupId,
		});
		return data;
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};

export const onDeleteManyStudents = async (students) => {
	try {
		const { data } = await inmersysVrApi.post(Endpoints.student.deletemany, {
			users: students,
		});
		return data;
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};

export const TrainingAddManyResponses = async (userResponses) => {
	try {
		const { data } = await inmersysVrApi.post(Endpoints.responses.addManyTraining, {
			responses: userResponses,
		});
		return data;
	} catch (error) {
		console.log("error", error.response.data.errors);
		return responseAxios(1, "error", error.response.data.errors);
	}
};
//

export const onDeleteLearingGroup = async (group) => {
	try {
        const url = Endpoints.gruop.deletegroup + group
        const { data } = await inmersysVrApi.delete(url);
		return data;
	} catch (error) {
		console.log("error", error.response);
		return responseAxios(1, "error", error.response.data.errors);
	}
};
